"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));
(0, _deprecate.default)({
  name: 'TextButton',
  newName: 'Button',
  changes: ['Text button has now become a style variant of the v2 Button component', 'Since the v1 TextButton was a styled version of the v1 Button, the two have been combined in the v2 Button component. All of the core functionality of both v1 button types has been included in the v2 Button.', '---- Props ----', 'iconPosition has been removed, iconLeft and iconRight have replaced it.', 'color was removed.', 'block was removed, if full width is needed, use isFullWidth', 'loading was replaced by isLoading']
});
const TextButton = ({
  className,
  children,
  href,
  iconPosition,
  block,
  disabled,
  loading,
  onClick,
  ...attrs
}) => {
  const classes = (0, _classnames.default)('TextButton', {
    'TextButton-block': block
  }, {
    'TextButton-loading': loading
  }, {
    [`TextButton-with-icon-${iconPosition}`]: iconPosition
  }, className);
  const tag = href ? 'a' : 'button';
  const opts = {
    className: classes,
    disabled,
    onClick,
    href,
    ...attrs
  };
  if (!href) {
    opts.type = 'button';
  }
  return /*#__PURE__*/_react.default.createElement(tag, opts, children);
};
var _default = exports.default = TextButton;